<template>
    <header class="header-global">
        <base-nav class="navbar-main" transparent type="" effect="light" expand>
            <router-link slot="brand" class="navbar-brand mr-lg-5" to="/">
		<h5 class="text-white" style="font-weight: bold;">APPSA</h5>
		<!--
                <img src="img/brand/appsa.hpng" alt="logo">
		-->
            </router-link>

            <div class="row" slot="content-header" slot-scope="{closeMenu}">
                <div class="col-6 collapse-brand">
                    <a href="/">
											<h5 class="text-primary" style="font-weight: bold;">APPSA</h5>
                      <img v-if="''" src="img/brand/blue.png">
                    </a>
                </div>
                <div class="col-6 collapse-close">
                    <close-button @click="closeMenu"></close-button>
                </div>
            </div>

            <ul class="navbar-nav navbar-nav-hover align-items-lg-center">
                <li class="nav-item">
                    <a slot="title" href="#/" class="nav-link" role="button">
                        <i class="ni ni-collection d-lg-none"></i>
                        <span class="nav-link-inner--text">Home</span>
                    </a>
                </li>
                <base-dropdown class="nav-item" menu-classes="dropdown-menu-xl">
                    <a slot="title" href="#" class="nav-link" data-toggle="dropdown" role="button">
                        <i class="ni ni-ui-04 d-lg-none"></i>
                        <span class="nav-link-inner--text">Services</span>
                    </a>
                    <router-link to="/team_extension" class="dropdown-item">IT Team Extension</router-link>
                    <router-link to="/maintenance_and_support" class="dropdown-item">Maintenance and Support</router-link>
                    <router-link to="/bot_project_financing" class="dropdown-item">BOT Project Financing</router-link>
                    <router-link to="/project_management" class="dropdown-item">Project Management</router-link>
                    <router-link to="/technology_research" class="dropdown-item">Technology Research</router-link>
                    <router-link to="/innovations" class="dropdown-item">Innovations</router-link>
                    <router-link to="/process_assessments" class="dropdown-item">Process Assessments</router-link>
                </base-dropdown>
                <base-dropdown tag="li" class="nav-item">
                    <a slot="title" href="#" class="nav-link" data-toggle="dropdown" role="button">
                        <i class="ni ni-collection d-lg-none"></i>
                        <span class="nav-link-inner--text">Technologies</span>
                    </a>
                    <router-link to="/cloud_computing" class="dropdown-item">Cloud Computing</router-link>
                    <router-link to="/intelligent_apps" class="dropdown-item">Intelligent Apps</router-link>
                    <router-link to="/data_analytics" class="dropdown-item">Data Analytics</router-link>
                    <router-link to="/blockchain" class="dropdown-item">Blockchain</router-link>
                    <router-link to="/artificial_intelligence" class="dropdown-item">Artificial Intelligence</router-link>
<div v-if="''">
                    <router-link to="/cybersecurity" class="dropdown-item">CyberSecurity</router-link>
                    <router-link to="/internet_of_things" class="dropdown-item">Internet of Things (IoT)</router-link>
                    <router-link to="/virtual_reality" class="dropdown-item">Virtual Reality</router-link>
</div>
                </base-dropdown>
                <base-dropdown tag="li" class="nav-item" v-if="''" >
                    <a slot="title" href="#" class="nav-link" data-toggle="dropdown" role="button">
                        <i class="ni ni-collection d-lg-none"></i>
                        <span class="nav-link-inner--text">Industries</span>
                    </a>
                    <router-link to="/transport_and_logistics" class="dropdown-item">Transport and Logistics</router-link>
                    <router-link to="/it_and_communications" class="dropdown-item">IT and Communications</router-link>
                    <router-link to="/consumer_goods_and_retail" class="dropdown-item">Consumer goods and Retail</router-link>
                    <router-link to="/education_and_research" class="dropdown-item">Education and Research</router-link>
                    <router-link to="/media_and_entertainment" class="dropdown-item">Media and Entertainment</router-link>
                    <router-link to="/banking_and_finance" class="dropdown-item">Banking and Finance</router-link>
                    <router-link to="/manufacturing" class="dropdown-item">Manufacturing</router-link>
                    <router-link to="/healthcare" class="dropdown-item">Helthcare</router-link>
                    <router-link to="/public_sector" class="dropdown-item">Public Sector</router-link>
                </base-dropdown>
                <li class="nav-item">
                    <a slot="title" href="#/contact" class="nav-link" role="button">
                        <i class="ni ni-collection d-lg-none"></i>
                        <span class="nav-link-inner--text">Contact</span>
                    </a>
                </li>
                <base-dropdown tag="li" class="nav-item">
                    <a slot="title" href="#" class="nav-link" data-toggle="dropdown" role="button">
                        <i class="ni ni-collection d-lg-none"></i>
                        <span class="nav-link-inner--text">Vacancies</span>
                    </a>
                    <router-link to="/project_manager" class="dropdown-item">Project Manager, Solution Architect</router-link>
                    <router-link to="/frontend_web_developer" class="dropdown-item">FrontEnd Web Developer</router-link>
                    <router-link to="/php_developer" class="dropdown-item">PHP Developer</router-link>
                    <router-link to="/node_developer" class="dropdown-item">Node Developer</router-link>
                    <router-link to="/java_developer" class="dropdown-item">Java Developer</router-link>
                    <router-link to="/python_developer" class="dropdown-item">Python Developer</router-link>
                    <router-link to="/ios_developer" class="dropdown-item">iOS Developer</router-link>
                    <router-link to="/android_developer" class="dropdown-item">Android Developer</router-link>
<div v-if="''">
                    <router-link to="/database_engineer" class="dropdown-item">Database Engineer</router-link>
                    <router-link to="/cloud_infrastructure_engineer" class="dropdown-item">Cloud Infrastructure Engineer</router-link>
                    <router-link to="/devops_engineer" class="dropdown-item">DevOps Engineer</router-link>
                    <router-link to="/web_designer" class="dropdown-item">Web Designer</router-link>
                    <router-link to="/data_scientist" class="dropdown-item">Data Scientist</router-link>
                    <router-link to="/ai_scientist" class="dropdown-item">AI Scientist</router-link>
</div>
                </base-dropdown>
            </ul>
            <ul class="navbar-nav align-items-lg-center ml-lg-auto">
                <li class="nav-item">
                    <a class="nav-link nav-link-icon" href="#/login" rel="noopener"
                       data-toggle="tooltip" title="Logiin to your account">
                        <i class="ni ni-single-02"></i>
                        <span class="nav-link-inner--text d-lg-none">Login</span>
                    </a>
                </li>
            </ul>
        </base-nav>
    </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";

export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown
  }
};
</script>
<style>
</style>
